'use client';
import React, { useEffect, useState } from 'react';
import { getMiningMachineExpires } from '../../api/getMiningMachineExpires';
import { MachineExpireEntry } from '../../types/mining/MachineExpire';

export default function MiningMachineExpires() {
  const [machineData, setMachineData] = useState<MachineExpireEntry[]>([]);

  useEffect(() => {
    getMiningMachineExpires()
      .then((response) => {
        const allExpires: MachineExpireEntry[] = response.flatMap((group) =>
          group.machineExpiresData.flat()
        );

        const sorted = allExpires.sort(
          (a, b) =>
            new Date(b.operationEnd).getTime() -
            new Date(a.operationEnd).getTime()
        );

        setMachineData(sorted);
      })
      .catch(console.error);
  }, []);

  return (
    <div className="m-5 p-5 bg-gray-100 rounded-lg shadow-lg">
      <h2 className="text-xl font-semibold text-gray-800 mb-4 text-center">
        Bányagépek hátralévő üzemideje
      </h2>

      {machineData.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="min-w-full border-separate border-spacing-y-1">
            <thead className="bg-gray-200 sticky top-0">
              <tr>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-600">Felhasználó</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-600">Csoport</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-600">Indulás dátuma</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-600">Leállás dátuma</th>
                <th className="px-4 py-2 text-right text-sm font-medium text-gray-600">Gépek száma</th>
              </tr>
            </thead>
            <tbody>
              {machineData.map((record, index) => (
                <tr
                  key={index}
                  className={
                    record.machineTurnedOff
                      ? 'bg-red-300 text-red-900'
                      : 'bg-green-300 text-green-900'
                  }
                >
                  <td className="px-4 py-2 text-md">{record?.user?.name}</td>
                  <td className="px-4 py-2 text-md">{record.groupName}</td>
                  <td className="px-4 py-2 text-md">{new Date(record.startDate).toLocaleDateString()}</td>
                  <td className="px-4 py-2 text-md">{new Date(record.operationEnd).toLocaleDateString()}</td>
                  <td className="px-4 py-2 text-md text-right">{record.numberOfMachines}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="text-center text-gray-600 mt-4">Nincs adat a bányagépekről.</p>
      )}
    </div>
  );
}
